import { defineStore } from 'pinia'
import { useUserStore } from "@/stores/user";
import router from "@/router";

export const usePackagesStore = defineStore('packages', {
  state: () => ({
    items: [],
    totalRecords: 0,
    loading: false,
    serverOptions: {
      page: 0,
      rows: 20,
      sortField: 'id',
      sortOrder: -1,
    },
  }),
  actions: {
    async index() {
      this.loading = true

      try {
        const organisation = useUserStore().user.organisation
        const kdnr = organisation?.kdnr || router.currentRoute.value.query.kdnr

        if (!kdnr) {
          this.items = []
          this.totalRecords = 0
          return {data: {packages: [], totalRecords: 0}}
        }

        const response = await this.apiClientV2.get('/packages', {
          params: {
            kdnr,
            page: this.serverOptions.page + 1,
            size: this.serverOptions.rows,
            sort_by: this.serverOptions.sortField || 'id',
            sort_order: this.serverOptions.sortOrder || -1,
          },
        })

        const responseData = response?.data
        const items = Array.isArray(responseData)
          ? responseData
          : responseData?.packages || responseData?.items || []

        this.items = items
        this.totalRecords = Number(
          responseData?.totalRecords
          || responseData?.total_count
          || responseData?.meta?.total
          || items.length
        )

        return response
      } finally {
        this.loading = false
      }
    },
  },
})
